import PriceDisplay from './price-display'

export default PriceDisplay
